export const QUERY_PARAMS_MAP = {
  redirectTo: 'r2',
};
